import { render } from "./SingleShift.vue?vue&type=template&id=35dd792f"
import script from "./SingleShift.vue?vue&type=script&lang=js"
export * from "./SingleShift.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__